import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Body, DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function Bezahlungsart() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <div className="flex flex-col gap-4">
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.label',
        )}
        item={t(
          'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.options.' +
            data.bezahlung.bezahlungsart.art,
        )}
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.verguetung.title',
        )}
        item={
          <div className="flex flex-col">
            <Body className="text-neutrals-900 font-semibold">
              {`${data.bezahlung.bezahlungsart.stundenlohn ?? '-'} €/Std.`}
            </Body>

            <Body className="text-neutrals-900 font-semibold">
              {`${data.bezahlung.bezahlungsart.monatsgehalt ?? '-'} €/Monat`}
            </Body>
          </div>
        }
      />
    </div>
  );
}
